import { Flex, Text, Icon, VStack, Box } from '@chakra-ui/react'
import { NavLink } from 'react-router-dom'
import { HiOutlineEye, HiOutlineScale, HiOutlineSwitchHorizontal, HiChartSquareBar } from 'react-icons/hi'

const navItems = [
  { id: 'watchlist', label: '观察列表', to: '/watchlist', icon: HiOutlineEye },
  { id: 'positions', label: '持仓列表', to: '/positions', icon: HiOutlineScale },
  { id: 'trades', label: '交易记录', to: '/trades', icon: HiOutlineSwitchHorizontal },
]

const SidebarNav = () => (
  <VStack as="nav" gap={1} align="stretch" px={3} py={4}>
    {/* Brand / Logo Area */}
    <Flex align="center" gap={3} px={3} mb={8} mt={2}>
      <Icon as={HiChartSquareBar} boxSize={6} color="brand.600" />
      <Text fontWeight="bold" fontSize="lg" letterSpacing="tight">
        RichCalls
      </Text>
    </Flex>

    {navItems.map((item) => (
      <NavLink key={item.id} to={item.to}>
        {({ isActive }) => (
          <Flex
            align="center"
            gap={3}
            px={3}
            py={2.5}
            borderRadius="md"
            bg={isActive ? 'bg.subtle' : 'transparent'}
            color={isActive ? 'text.main' : 'text.muted'}
            transition="all 0.2s"
            _hover={{
              bg: isActive ? 'bg.subtle' : 'bg.subtle',
              color: 'text.main',
            }}
          >
            <Icon
              as={item.icon}
              boxSize={5}
              color={isActive ? 'brand.600' : 'inherit'}
            />
            <Text fontSize="sm" fontWeight={isActive ? '600' : '500'}>
              {item.label}
            </Text>
          </Flex>
        )}
      </NavLink>
    ))}
  </VStack>
)

export default SidebarNav
